import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kaya_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('kaya_token');
      localStorage.removeItem('kaya_user');
      if (window.location.pathname.startsWith('/admin/dashboard')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// Helper to build image URLs
export const imageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};

// ============= AUTH =============
export const authAPI = {
  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('kaya_token', data.token);
    localStorage.setItem('kaya_user', JSON.stringify(data.user));
    return data;
  },
  logout: () => {
    localStorage.removeItem('kaya_token');
    localStorage.removeItem('kaya_user');
  },
  me: async () => {
    const { data } = await api.get('/auth/me');
    return data;
  },
  getUser: () => {
    const u = localStorage.getItem('kaya_user');
    return u ? JSON.parse(u) : null;
  },
  isAuthenticated: () => !!localStorage.getItem('kaya_token'),
};

// ============= PROPERTIES =============
export const propertiesAPI = {
  list: async (params = {}) => {
    const { data } = await api.get('/properties', { params });
    return data;
  },
  get: async (id) => {
    const { data } = await api.get(`/properties/${id}`);
    return data;
  },
  create: async (formData) => {
    const { data } = await api.post('/properties', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
  update: async (id, formData) => {
    const { data } = await api.put(`/properties/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
  delete: async (id) => {
    const { data } = await api.delete(`/properties/${id}`);
    return data;
  },
  removeImage: async (id, image_url) => {
    const { data } = await api.delete(`/properties/${id}/images`, {
      params: { image_url },
    });
    return data;
  },
};

// ============= CONTACT =============
export const contactAPI = {
  submit: async (payload) => {
    const { data } = await api.post('/contact', payload);
    return data;
  },
  listMessages: async () => {
    const { data } = await api.get('/contact/messages');
    return data;
  },
  updateStatus: async (id, new_status) => {
    const fd = new FormData();
    fd.append('new_status', new_status);
    const { data } = await api.put(`/contact/messages/${id}`, fd);
    return data;
  },
  deleteMessage: async (id) => {
    const { data } = await api.delete(`/contact/messages/${id}`);
    return data;
  },
};

// ============= SITE CONTENT (CMS) =============
export const siteAPI = {
  get: async () => {
    const { data } = await api.get('/site-content');
    return data;
  },
  update: async (payload) => {
    const { data } = await api.put('/site-content', payload);
    return data;
  },
};

export default api;